import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CertificationsSection = () => {
  const commitments = [
    {
      icon: "Award",
      title: "Entreprise française certifiée",
      description: "Société immatriculée en France avec toutes les autorisations nécessaires"
    },
    {
      icon: "Shield",
      title: "Assurance tous risques incluse",
      description: "Vos colis sont protégés de la collecte jusqu\'à la livraison finale"
    },
    {
      icon: "Lock",
      title: "Conteneurs sécurisés et scellés",
      description: "Chaque conteneur est scellé et suivi tout au long du voyage maritime"
    },
    {
      icon: "Headphones",
      title: "Service client disponible 7j/7",
      description: "Une équipe à votre écoute par téléphone, WhatsApp et email"
    }
  ];

  return (
    <div className="py-16 sm:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Nos engagements
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            Votre confiance est notre priorité
          </p>
        </motion.div>

        {/* Commitments Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {commitments?.map((commitment, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              {/* Icon Circle */}
              <div className="flex justify-center mb-4">
                <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center shadow-lg">
                  <Icon name={commitment?.icon} size={32} color="white" />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {commitment?.title}
              </h3>
              <p className="text-sm text-slate-600">
                {commitment?.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CertificationsSection;